import {createFileRoute, redirect} from '@tanstack/react-router'
import {isAuthenticated} from "../utils/auth.ts";
import ForgotPasswordForm from "../components/Auth/ForgotPasswordForm.tsx";

export const Route = createFileRoute('/forgot-password')({
  beforeLoad: async () => {
    if(isAuthenticated()) {
      throw redirect({to: '/sessions', replace: true});
    }
  },
  component: ForgotPasswordForm
});
